import { Component } from 'react';

import logError from 'utils/rollbar';

import AppError from './common/components/apiError/AppError';

class AppErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false
    };
  }

  componentDidCatch(error, info) {
    this.setState((state) => ({ ...state, hasError: true }));
    logError(error, info);
  }

  render() {
    const { props, state } = this;
    if (!state.hasError) {
      return props.children;
    }
    return <AppError />;
  }
}

export default AppErrorBoundary;
